export default __webpack_public_path__ + "static/intelligent-investor-v3-fb204baeb3770f6063351bb56442278b.svg";